import { useDispatch, useSelector } from "react-redux";
import { useEffect, useMemo } from "react";
import { useRouter } from "next/router";
import styles from "./index.module.scss";
import Bottom from "/components/pages/productNew/bottom";
import BuyWithThis from "../buyWithThis";
import Files from "../files";
import Services from "../services";
import Images from "../images";
import Share from "../share";
import Brand from "../brand";
import { formatType, getProductsPhotos } from "../../../../utils";
import Sert from "../sert";
import { fetchProductReviewsAndQuestionsById } from "../../../../redux/action-creaters/reviewsAndQuestions";
import ProductPageWrapper from "../bodyWrapper";
import Manager from "../manager";
import Stick from "../stick";
import Props from "../props";
import Offer from "../offer";
import CommunicateTop from "../communicateTop";
import Communicate from "../communicate";
import OfferWithElectric from "../offerWithElectric";
import CopyArticleButton from "/components/common/copyArticleButton";
import {
  ECOMMERCE_LISTS,
  sendVisitParams,
  useEcommerceDetail,
} from "../../../../utils/tracking";

export default function ProductBody() {
  const { cityName } = useSelector((state) => state.location);
  const { product } = useSelector((state) => state.product);
  const { isMobile } = useSelector((state) => state.pageState);
  const { host } = useSelector((state) => state.params);

  const { description } = useSelector((state) => state.meta);
  const dispatch = useDispatch();
  const router = useRouter();
  useEffect(() => {
    dispatch(
      fetchProductReviewsAndQuestionsById(
        product.ID,
        "",
        Boolean(router.query.reset),
      ),
    );
  }, [product]);

  useEcommerceDetail(product, ECOMMERCE_LISTS.detail);

  const photos = getProductsPhotos(product);

  const isAlailable = useMemo(() => {
    return product.CATALOG.AVAILABLE;
  }, [product]);

  // eslint-disable-next-line no-unused-vars
  const { user } = useSelector((state) => state.user);

  // Наличие товара в параметры визита Метрики (Б24 №108345): кнопка
  // покупки в карточке есть ровно при AVAILABLE — значит в наличии.
  useEffect(() => {
    sendVisitParams(
      { "Наличие товара": isAlailable ? "В наличии" : "Нет в наличии" },
      user,
    );
  }, [product.ID]);

  const isAdminUser =
    user?.IS_ADMIN || user?.IS_MANAGER || Boolean(router.query.isManager);

  const subDomain = useMemo(() => (host ? host.split(".")[0] : ""), [host]);
  const showLifetimeWarranty = useMemo(() => {
    // eslint-disable-next-line eqeqeq
    const isFarkopOnly =
      // eslint-disable-next-line eqeqeq
      product.IBLOCK_SECTION_ID == "635";

    return (
      ["msk", "spb", "nn", "kirov", "ulyanovsk", "petrozavodsk"].includes(
        subDomain,
      ) &&
      Boolean(isAlailable) &&
      isFarkopOnly
    );
  }, [subDomain, isAlailable, product]);

  return (
    <ProductPageWrapper
      head={
        <>
          <div className={styles.TopH1}>{formatType(product.NAME)}</div>

          <div className={styles.Top}>
            <span className={styles.TopArt}>
              Артикул: {product.ARTICLE?.VALUE}
              {isAdminUser && (
                <CopyArticleButton article={product.ARTICLE?.VALUE} />
              )}
            </span>
            <div className={styles.TopRight}>
              <CommunicateTop productId={product.ID} />
              <Share
                productName={product.NAME}
                productUrl={product.DETAIL_PAGE_URL}
                photo={`${photos?.[0] && `${photos[0]}/small.webp`}`}
              />
            </div>
          </div>
        </>
      }
      left={
        <div id="productImages" className={styles.Photos}>
          <Stick
            stick={product.STICK}
            lifetimeWarranty={showLifetimeWarranty}
          />
          <Images
            productId={product.ID}
            isMobile={isMobile}
            images={photos}
            imageIds={product.PHOTOS_NEW}
            video={product.VIDEO}
            alt={`${product.NAME} ${product.ARTICLE?.VALUE} в ${cityName}`}
          />
        </div>
      }
      bottom={
        <div>
          <Bottom video={product.VIDEO} />
          <Communicate />
          <BuyWithThis products={product.BUY_WITH_THIS_PRODUCTS} />
        </div>
      }
    >
      <>
        <div className={styles.MainInfo}>
          <div className={styles.Props}>
            <h1 itemProp="name">{formatType(product.NAME)}</h1>
            <div style={{ display: "none" }} itemProp="description">
              {description}
            </div>
            <Manager productId={product.ID} product={product} />
            {product.PROPERTIES.length > 0 && (
              <div className={styles.PropsBlock}>
                <div className={styles.PropsTitle}>О товаре</div>
                <Props
                  props={product.PROPERTIES}
                  filterUrl={product.FILTER_URL}
                />
              </div>
            )}

            <div className={styles.FilesAndBrands}>
              <div className={styles.Files}>
                <Files file={product.FILE} />
                <Sert sert={product.CERT} />
              </div>
              <Brand data={product.BRAND} />
            </div>
          </div>
          {product.CATALOG && (
            <div>
              <div className={styles.Buy}>
                {(isAlailable || isAdminUser) &&
                // eslint-disable-next-line eqeqeq
                (product.IBLOCK_SECTION_ID == "635" ||
                  // eslint-disable-next-line eqeqeq
                  product.IBLOCK_SECTION_ID == "636") ? (
                  <OfferWithElectric
                    isDetail={true}
                    isShowSplit={true}
                    product={product}
                    key={product.ID}
                  />
                ) : (
                  <Offer
                    isDetail={true}
                    isShowSplit={true}
                    product={product}
                    key={product.ID}
                  />
                )}
              </div>
              <Services
                sectionId={product.IBLOCK_SECTION_ID}
                marka={product.MARKA?.CODE_ALT}
              />
            </div>
          )}
        </div>
      </>
    </ProductPageWrapper>
  );
}
